import styled from "styled-components";
import InputIcon from "@material-ui/icons/Input";

const getStatusColor = (taskStatus) => {
  switch (taskStatus) {
    case "done":
      return "#49b446";
    case "doing":
      return "#f8e47c";
    case "late":
      return "#eb5757";
    default:
      return "#fff";
  }
};

export const Container = styled.div`
  margin-top: 0.6rem;
  display: flex;
  flex-direction: column;
  width: 97%;
  background-color: #fff;
  box-shadow: 0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08);
  border-radius: 4.22206px;

  user-select: none;
  cursor: pointer;

  &:hover {
    background: #cff8e7;
  }

  transition: 0.15s ease-in-out background;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  min-height: 5rem;
  padding: 0.5rem;
  box-sizing: border-box;
`;

export const ChatBlock = styled.div`
  justify-self: end;
  width: 100%;
  padding-bottom: 0.5rem;
  background-color: #c6c7c8;
  border-radius: 15px;
`;

export const TaskName = styled.span`
  width: 36%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.1rem;
  cursor: pointer;
`;

export const TaskChat = styled.div`
  width: 5%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  path {
    stroke: #7e858f;
  }
`;

export const GotoIcon = styled(InputIcon)`
  cursor: pointer;
  align-items: center;
  background-color: #585e66;
  padding: 0.2rem;
  border-radius: 5px;
  stroke: ${({ taskStatus }) => getStatusColor(taskStatus)};
  color: ${({ taskStatus }) => getStatusColor(taskStatus)};
`;
